import React, { useState, useEffect } from 'react';
import './Styles/AnalyticsMain.css';
import IUDetail from '../../Components/AnalyticsIU/IUDetail';
import { useSelector } from 'react-redux';
import { DataApi } from '../../API';

import { useLoadingState } from '../../context/LoadingContext';
function AnalyticsInflowUrl(props) {
  props.setCurrentPage(props.pageTitle);
  const [, setLoading] = useLoadingState(true);
  const currentSite = useSelector((state) => state.currentSite);
  const period = useSelector((state) => state.period);
  const comparePeriod = useSelector((state) => state.comparePeriod);
  const [data, setData] = useState([]);
  useEffect(() => {
    try {
      setLoading(true);
      const getApi = async () => {
        const data = await DataApi.getIncomeUrl(
          currentSite.script_code,
          period,
          comparePeriod
        );
        setData(data);
      };
      getApi();
    } catch (e) {
      console.error(e.message);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [currentSite, period, comparePeriod]);
  return (
    <>
      <IUDetail data={data} />
    </>
  );
}

export default AnalyticsInflowUrl;
